<div class="modal-header">
    <h4 class="modal-title" translate>{{text.header}}</h4>
</div>
<div class="modal-body u--text-center">
    <p>Zeskanuj poniższy kod w aplikacji typu Authenticator oraz wprowadź 6-cyfrowy kod.</p>
    <img src="{{qrCodeUrl}}" />
    <div>
        <label for="password" class="u--text-uppercase">Token</label>
        <input name="token"
            type="password"
            [(ngModel)]="token"
            placeholder="Token"
        >
    </div>
    <app-error-message [apiError]="formErrors?.non_field_errors || formErrors"></app-error-message>
</div>
<div class="modal-footer mt-3">
    <button class="btn btn-primary px-xl btn-border" (click)="activeModal.dismiss()" translate>CANCEL</button>
    <button class="btn btn-danger px-xl" (click)="onApplyClick()" [disabled]="pending" translate>
        <app-spinner [showSpinner]="pending"></app-spinner>
        {{text.submit}}
    </button>
</div>
